import React from 'react'
import Loadable from 'react-loadable'
import DefaultLayout from './containers/DefaultLayout'
import { getCurrentAccount } from './services/session/sessionState'

function Loading() {
  return (
    <p>
      <em>Cargando...</em>
    </p>
  )
}

const Account = Loadable({
  loader: () => import('./views/Account/Account'),
  loading: Loading
})
const AccountChange = Loadable({
  loader: () => import('./views/Account/AccountChange'),
  loading: Loading
})
const AccountContacts = Loadable({
  loader: () => import('./views/Account/AccountContacts'),
  loading: Loading
})
const AccountDashboard = Loadable({
  loader: () => import('./views/Account/AccountDashboard'),
  loading: Loading
})
const Documents = Loadable({
  loader: () => import('./views/Documents/Documents'),
  loading: Loading
})
const DocumentDetail = Loadable({
  loader: () => import('./views/Documents/DocumentDetails'),
  loading: Loading
})
const Checkout = Loadable({
  loader: () => import('./views/Checkout/Checkout'),
  loading: Loading
})
const Catalog = Loadable({
  loader: () => import('./views/Catalog/Catalog'),
  loading: Loading
})
const Assortment = Loadable({
  loader: () => import('./views/Catalog/Catalog'),
  loading: Loading
})
const Providers = Loadable({
  loader: () => import('./views/Provider/ProviderList'),
  loading: Loading
})
const ProviderDetail = Loadable({
  loader: () => import('./views/Provider/ProviderDetail'),
  loading: Loading
})
const IrpIncidences = Loadable({
  loader: () => import('./views/IrpIncidences/IrpIncidences'),
  loading: Loading
})
const IrpIncidenceDetail = Loadable({
  loader: () => import('./views/IrpIncidences/IrpIncidenceDetail'),
  loading: Loading
})
const NonConformityIncidences = Loadable({
  loader: () => import('./views/NonConformityIncidences/NonConformityIncidences'),
  loading: Loading
})
const NonConformityIncidenceDetail = Loadable({
  loader: () => import('./views/NonConformityIncidences/NonConformityIncidenceDetail'),
  loading: Loading
})
const ProviderChart = Loadable({
  loader: () => import('./views/Provider/ProviderChart'),
  loading: Loading
})
const Stocks = Loadable({
  loader: () => import('./views/Stocks/Stocks'),
  loading: Loading
})
const ProviderReports = Loadable({
  loader: () => import('./views/ProviderReports/ProviderReports'),
  loading: Loading
})
const CatalogDetail = Loadable({
  loader: () => import('./views/CatalogDetail/CatalogDetail'),
  loading: Loading
})
const Promotions = Loadable({
  loader: () => import('./views/Promotions/Promotions'),
  loading: Loading
})
const Brochure = Loadable({
  loader: () => import('./views/Brochure/Brochure'),
  loading: Loading
})
const Orders = Loadable({
  loader: () => import('./views/Orders/Orders'),
  loading: Loading
})
const OrderDetail = Loadable({
  loader: () => import('./views/Orders/OrderDetails'),
  loading: Loading
})
const OrderTemplates = Loadable({
  loader: () => import('./views/OrderTemplates/OrderTemplates'),
  loading: Loading
})
const OrderTemplateDetail = Loadable({
  loader: () => import('./views/OrderTemplates/OrderTemplateDetails'),
  loading: Loading
})
const Incidences = Loadable({
  loader: () => import('./views/Incidences/Incidences'),
  loading: Loading
})
const IncidenceDetails = Loadable({
  loader: () => import('./views/Incidences/IncidenceDetails'),
  loading: Loading
})
const Balances = Loadable({
  loader: () => import('./views/Balances/Balances'),
  loading: Loading
})
const Receipts = Loadable({
  loader: () => import('./views/Receipts/Receipts'),
  loading: Loading
})
const M347 = Loadable({
  loader: () => import('./views/M347/M347'),
  loading: Loading
})
const OnlineSupport = Loadable({
  loader: () => import('./views/Help/OnlineSupport'),
  loading: Loading
})
const FAQ = Loadable({
  loader: () => import('./views/Help/FAQ'),
  loading: Loading
})
const Contact = Loadable({
  loader: () => import('./views/Help/Contact'),
  loading: Loading
})
const PickUps = Loadable({
  loader: () => import('./views/PickUp/PickUps'),
  loading: Loading
})
const PickUpDetails = Loadable({
  loader: () => import('./views/PickUp/PickUpDetails'),
  loading: Loading
})
const Routes = Loadable({
  loader: () => import('./views/Route/Routes'),
  loading: Loading
})
const AppointmentsConfiguration = Loadable({
  loader: () => import('./views/AppointmentsConfiguration/AppointmentsConfiguration'),
  loading: Loading
})
const VendorRoutes = Loadable({
  loader: () => import('./views/VendorRoutes/VendorRoutes'),
  loading: Loading
})
const Files = Loadable({
  loader: () => import('./views/Files/Files'),
  loading: Loading
})
const Reporting = Loadable({
  loader: () => import('./views/Files/Reporting'),
  loading: Loading
})
const Links = Loadable({
  loader: () => import('./views/Help/Links'),
  loading: Loading
})
const Planogram = Loadable({
  loader: () => import('./views/Planogram/Planogram'),
  loading: Loading
})
const WebGroupReportDetail = Loadable({
  loader: () => import('./views/WebGroupReport/WebGroupReportDetail'),
  loading: Loading
})
// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Home', component: DefaultLayout },
  { path: '/account', name: 'Cuenta', component: Account },
  {
    path: '/accountcontacts',
    exact: true,
    name: 'Contactos',
    component: AccountContacts
  },
  { path: '/accountdashboard', name: 'Estado', component: AccountDashboard },
  {
    path: '/accountchange',
    name: 'Cambio de cuenta',
    component: AccountChange
  },
  {
    path: '/documents',
    exact: true,
    name: 'Facturas/Albaranes',
    component: Documents
  },
  {
    path: '/documentdetails/:id',
    exact: true,
    name: 'Detalle Documento',
    component: DocumentDetail
  },
  {
    path: '/checkout',
    exact: true,
    name: 'Realizar pedido',
    component: Checkout
  },
  {
    path: '/catalog',
    exact: true,
    name: 'Catálogo',
    component: Catalog,
    isAllowed: () => getCurrentAccount().mostrarSeccionMisProductos
  },
  {
    path: '/catalog/:id',
    exact: true,
    name: 'Detalle Catálogo',
    component: CatalogDetail
  },
  {
    path: '/assortment',
    exact: true,
    name: 'Surtido',
    component: Assortment
  },
  {
    path: '/assortment/:id',
    exact: true,
    name: 'Detalle Surtido',
    component: CatalogDetail
  },
  {
    path: '/providers',
    exact: true,
    name: 'Proveedores',
    component: Providers
  },
  {
    path: '/providers/:id',
    exact: true,
    name: 'Detalle del proveedor',
    component: ProviderDetail
  },
  {
    path: '/providers/:id/chart',
    exact: true,
    name: 'Reporte del proveedor',
    component: ProviderChart
  },
  { path: '/stocks', exact: true, name: 'Stocks', component: Stocks },
  {
    path: '/providerreports',
    exact: true,
    name: 'Reportes',
    component: ProviderReports
  },
  {
    path: '/irpincidences',
    exact: true,
    name: 'Incidencias IRP',
    component: IrpIncidences
  },
  {
    path: '/irpincidences/:id',
    exact: true,
    name: 'Detalle de la incidencia IRP',
    component: IrpIncidenceDetail
  },
  {
    path: '/nonconformityincidences',
    exact: true,
    name: 'Incidencias de no conformidad',
    component: NonConformityIncidences
  },
  {
    path: '/nonconformityincidences/:id',
    exact: true,
    name: 'Detalle de la incidencia de no conformidad',
    component: NonConformityIncidenceDetail
  },
  {
    path: '/promotions',
    exact: true,
    name: 'Promociones',
    component: Promotions
  },
  { path: '/brochure', exact: true, name: 'Catálogo', component: Brochure },
  { path: '/order', exact: true, name: 'Pedidos', component: Orders },

  { path: '/orders/:filter', exact: true, name: 'Enviados a Conway', component: Orders },

  {
    path: '/orderdetails/:id',
    exact: true,
    name: 'Detalle Pedido',
    component: OrderDetail
  },
  {
    path: '/ordertemplate',
    exact: true,
    name: 'Plantillas de pedido',
    component: OrderTemplates
  },
  {
    path: '/ordertemplatedetails/:id',
    exact: true,
    name: 'Detalle Plantilla de pedido',
    component: OrderTemplateDetail
  },
  { path: '/incidences', exact: true, name: 'Incidencias', component: Incidences },
  { path: '/incidences/:filter', exact: true, name: 'Incidencias', component: Incidences },
  {
    path: '/incidencedetails/:id',
    exact: true,
    name: 'Detalle Incidencia',
    component: IncidenceDetails
  },
  {
    path: '/balances',
    exact: true,
    name: 'Condiciones de pago y saldo pendiente',
    component: Balances
  },
  {
    path: '/receipts',
    exact: true,
    name: 'Recibos emitiods',
    component: Receipts
  },
  {
    path: '/m347',
    exact: true,
    name: 'M347',
    component: M347
  },
  {
    path: '/onlinesupport',
    exact: true,
    name: 'Soporte Online',
    component: OnlineSupport
  },
  { path: '/faq', exact: true, name: 'Preguntas frecuentes', component: FAQ },
  { path: '/contact', exact: true, name: 'Contacto', component: Contact },
  {
    path: '/pickups',
    exact: true,
    name: 'Recogidas/Abonos',
    component: PickUps
  },
  {
    path: '/pickups/:filter',
    exact: true,
    name: 'Recogidas/Abonos',
    component: PickUps
  },
  {
    path: '/pickupdetails/:id',
    exact: true,
    name: 'Detalles Recogidas/Abonos',
    component: PickUpDetails
  },
  { path: '/routes', exact: true, name: 'Rutas', component: Routes },
  {
    path: '/appointments-configuration',
    name: 'Appointments Configuration',
    exact: true,
    component: AppointmentsConfiguration
  },
  { path: '/routes-vendor', exact: true, name: 'Vendedor', component: VendorRoutes },
  { path: '/routes-vendor/:id', exact: true, name: 'Vendedor', component: VendorRoutes },
  { path: '/files', exact: true, name: 'Manuales', component: Files },
  { path: '/reporting', exact: true, name: 'Reporting', component: Reporting },
  { path: '/links', exact: true, name: 'Links', component: Links },
  {
    path: '/web-group-report/:id',
    exact: true,
    name: 'Reporte de web group',
    component: WebGroupReportDetail
  },
  { path: '/planogram', exact: true, name: 'Planograma', component: Planogram }
]

export default routes
